// YARD design system tokens — shared across all YARD components
export const INK     = '#0A0A0A';
export const SURFACE = '#111114';
export const TEXT    = '#EFEEEA';
export const MUTED   = 'rgba(239,238,234,.55)';
export const RULE    = 'rgba(255,255,255,.08)';
export const ACCENT  = '#B8860B'; // Lamborghini dark gold
export const GOLD    = '#B8860B';

export const mono    = '"IBM Plex Mono", ui-monospace, monospace';
export const grotesk = '"Space Grotesk", "Helvetica Neue", sans-serif';
